import React from 'react';
import ValeDictory  from 'views/ValeDictory';

const ClassAssemblyPage = () => {
    return <ValeDictory />;
  };
  
  export default ClassAssemblyPage;